import React from 'react';
import { WrappedComponentProps, injectIntl, useIntl } from 'react-intl';

export interface ITextInputProps {
    name: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    maxLength?: number;
    placeholder?: string;
    value?: string | number;
    title?: string;
    error?: string;
    showError?: boolean;
    required?: boolean;
    className?: string;
    disabled?: boolean;
    onBlur?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    customLabel?: boolean;
}

interface ITextInputBaseProps extends ITextInputProps {
    type: string;
}

const TextInputBase = ({
    type,
    name,
    onChange,
    maxLength,
    placeholder,
    className,
    value,
    title,
    error,
    showError,
    disabled,
    onBlur,
}: ITextInputBaseProps) => {
    const intl = useIntl();
    let wrapperClass = '';
    if (error && error.length > 0) {
        wrapperClass += ' has-error';
    }

    return (
        <div className={wrapperClass}>
            <input
                type={type}
                name={name}
                className={className}
                placeholder={
                    placeholder
                        ? intl.formatMessage({
                              id: placeholder,
                              defaultMessage: placeholder.replace(/_/g, ' '),
                          })
                        : undefined
                }
                maxLength={maxLength}
                value={value}
                title={title}
                onChange={onChange}
                disabled={disabled}
                readOnly={disabled}
                onBlur={onBlur}
            />
            {error && <div className="alert alert-danger">{error}</div>}
        </div>
    );
};

export default TextInputBase;
